var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { sortByFunc } from '../../../../utils/helper/lodash_replacements';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
export class FunnelReward {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get funnel() {
        return this.parent;
    }
    get app() {
        return this.funnel.app;
    }
    get rewardTopic() {
        if (this.app.pathURI.includes('/klasse7/')) {
            return this.app.model.stream.location['abfrager.de/gymnasium/klasse7/gemischt/rewards'];
        }
        if (this.app.pathURI.includes('/klasse6/')) {
            return this.app.model.stream.location['abfrager.de/gymnasium/klasse6/gemischt/rewards'];
        }
        if (this.app.pathURI.includes('/klasse5/')) {
            return this.app.model.stream.location['abfrager.de/gymnasium/klasse5/gemischt/rewards'];
        }
        if (this.app.pathURI.includes('/klasse4/')) {
            return this.app.model.stream.location['abfrager.de/grundschule/klasse4/sachunterricht/rewards'];
        }
        if (this.app.pathURI.includes('/klasse3/')) {
            return this.app.model.stream.location['abfrager.de/grundschule/klasse3/sachunterricht/rewards'];
        }
        if (this.app.pathURI.includes('/klasse2/')) {
            return this.app.model.stream.location['abfrager.de/grundschule/klasse2/sachunterricht/rewards'];
        }
        return this.app.model.stream.location['abfrager.de/grundschule/klasse1/sachunterricht/rewards'];
    }
    get allRewards() {
        if (!this.rewardTopic)
            return [];
        if (!this.app.appBoot.isInteractive)
            return [];
        return this.rewardTopic.topicMiniQuestions.miniQuestions;
    }
    get incomingRewards() {
        const filtered = this.allRewards.filter(mini => !!this.app.user.userStore.rewardCategories.find(category => mini.micro.subtopicName.includes(category)));
        const run1 = filtered.filter(mini => mini.miniPassState.questionState === QuestionPassStateId.New);
        if (run1.length > 0)
            return run1;
        const run2 = filtered.filter(mini => mini.miniPassState.questionState === QuestionPassStateId.Passed);
        if (run2.length > 0)
            return run2;
        const run3 = filtered.filter(mini => mini.miniPassState.questionState === QuestionPassStateId.Passed2);
        if (run3.length > 0)
            return run3;
        return [];
    }
    get remainingMiniRewardsSortedByPriority() {
        return this.incomingRewards
            .concat()
            .sort(sortByFunc((mini) => mini.miniRewardScore.scoreTotal))
            .reverse();
    }
}
__decorate([
    computed
], FunnelReward.prototype, "rewardTopic", null);
__decorate([
    sortedSet
], FunnelReward.prototype, "remainingMiniRewardsSortedByPriority", null);
